<template>
    <div>
        <navBar title="隐私政策" color="#ffffff"></navBar>
        <div class="content">
            <p style="text-align: center;">
                <span style="color: rgb(0, 0, 0); ">隐私权政策</span>
            </p>
            <p style="margin:15px auto;">
                <span style="color: rgb(0, 0, 0); ">发布日期：2023年2月14日</span></p>
            <p style="margin-bottom: 15px;"><span  style="color: rgb(0, 0, 0); ">生效日期：2023年2月14日</span>
            </p>
            <p style="text-indent: 24pt; "><span
                            style="color: rgb(0, 0, 0); ">您的信任对我们非常重要，我们深知个人信息对您的重要性，我们将按法律法规要求，并恪守以下原则保护您的个人信息：</span>
                            <u
                            class="token bold"><span>权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则。</span></u><span
                            style="color: rgb(0, 0, 0); ">鉴此，我们特制定本《隐私权政策》（下称“本政策/本隐私权政策”）并提醒您：</span>
            </p>
            <p style="text-indent: 24.1pt; "><u
                            class="token bold"><span>在使用杭州聚收科技有限公司（简称“聚收”或者“我们”）各项产品或服务（包括但不限于我们运营的微信公众号）前，请您务必仔细阅读并透彻理解本政策，特别是以粗体和/或下划线标识的条款，在确认充分理解并同意后使用相关产品或服务。一旦您开始使用聚收的各项产品或服务，即表示您已充分理解并同意本政策</span></u>
                            <u><span>。如您拒绝本政策，您仍然能够在无注册/登录状态下浏览，您也可以在后续的使用中进行单独授权。</span></u>
            </p>
            <p style="text-indent: 24.1pt; "><u
                            class="token bold"><span>我们尊重知识产权，反对并打击侵犯知识产权的行为。知识产权权利人若认为聚收提供的服务上的内容侵犯其合法权益的，可以进行投诉，我们将在收到知识产权权利人合格通知后依据相应的法律法规及时处理。</span></u>
            </p>
            <p ><span style="color: rgb(0, 0, 0); ">本政策将帮助您了解以下内容：</span></p>
            <p ><span style="color: rgb(0, 0, 0); ">1、我们如何收集和使用您的个人信息</span></p>
            <p ><span style="color: rgb(0, 0, 0); ">2、我们如何使用Cookie和同类技术</span></p>
            <p ><span style="color: rgb(0, 0, 0); ">3、我们如何共享、转让、公开披露您的个人信息</span>
            </p>
            <p ><span style="color: rgb(0, 0, 0); ">4、我们如何保护您的个人信息</span></p>
            <p ><span style="color: rgb(0, 0, 0); ">5、您的权利</span></p>
            <p ><span
                            style="color: rgb(0, 0, 0); ">6、我们如何处理儿童的个人信息</span></p>
            <p ><span
                            style="color: rgb(0, 0, 0); ">7、您的个人信息如何在全球范围转移</span></p>
            <p ><span
                            style="color: rgb(0, 0, 0); ">8、本政策如何更新</span></p>
            <p ><span
                            style="color: rgb(0, 0, 0); ">9、本政策的适用</span></p>
            <p ><span
                            style="color: rgb(0, 0, 0); ">10、争议解决</span></p>
            <p ><span
                            style="color: rgb(0, 0, 0); ">11、联系我们</span></p>
            <p style="text-indent: 7.5pt; "><strong
                            class="token bold"><span>一、我们如何收集和使用您的个人信息</span></strong></p>
            <p style="text-indent: 24.1pt; ">
                个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。我们仅会出于本政策所述的以下目的、方式、范围在为您提供阅读服务时收集和使用您的个人信息：
            </p>
            <p ><span>1、应用功能一：成为注册用户</span></p>
            <p style="text-indent: 24pt; "><span
                            style="color: rgb(0, 0, 0); ">您在申请成为本公众号（指杭州聚收科技有限公司运营的公众号，下同）注册用户时，您需提供以下信息：您的手机号、创建的用户名和/或密码。您也可以使用微信登录本产品。您提供的上述信息，授权我们在为您使用本服务期间持续使用。在您注销账号时，我们将停止使用并删除上述信息。</span>
            </p>
            <p ><span>2、应用功能二：操作日志及个性化推荐</span></p>
            <p style="text-indent: 24pt; "><span
                            style="color: rgb(0, 0, 0); ">您使用我们服务时，我们会记录您的操作日志，包括搜索关键字、累计阅读或使用时长、读过的书籍和章节、创建和收藏的书单、参与的活动等。我们会基于前述信息对您的偏好、阅读习惯、使用产品的特征进行分析和用户画像，以便为您提供个性化、定制化的服务，如向您展现或推荐相关程度更高的服务。</span>
            </p>
            <p ><span>3、应用功能三：支付</span></p>
            <p id="w-e-element-343" style="text-indent: 24pt; "><span
                            style="color: rgb(0, 0, 0); ">您使用本产品时，电子书付费章节等服务时产生的记录，包括订购记录、消费记录，这些信息会存储于我们的服务器中。</span>
            </p>
            <p id="w-e-element-344" style="text-indent: 24.1pt; ">以上信息为产品功能必须的信息，如您不同意我们记录前述信息，我们将无法为您提供书籍购买和阅读服务。
            </p>
            <p id="w-e-element-345" ><span>4、应用功能五：安全服务</span></p>
            <p id="w-e-element-346" style="text-indent: 24pt; "><span
                            style="color: rgb(0, 0, 0); ">为向您提供安全稳定的服务、保障您的账户财产安全、预防冒名登陆，为了正常使用本产品功能及服务，当您使用我们的产品或服务时，我们可能会自动记录某些信息，包括：设备信息，例如您的移动设备、网页浏览器或用于接入我们服务的其他程序所提供的配置信息、您的IP地址和移动设备所用的版本和设备识别码（IMEI）、手机串号识别码（MAC）等信息。</span>
            </p>
            <p id="w-e-element-347" style="text-indent: 24pt; "><span
                            style="color: rgb(0, 0, 0); ">如果您不同意我们记录前述信息，可能无法完成风控流程而无法使用我们的产品。</span>
            </p>
            <p id="w-e-element-348" ><span
                            style="color: rgb(0, 0, 0); ">5、应用功能六：权限启用</span></p>
            <p id="w-e-element-349" style="text-indent: 24pt; "><span
                            style="color: rgb(0, 0, 0); ">我们承诺决不超范围、超频次搜集您的个人信息，决不搜集与使用本产品服务非必需或无合理应用场景的信息。</span>
            </p>
            <p id="w-e-element-350" style="text-indent: 24pt; "><span
                            style="color: rgb(0, 0, 0); ">您在使用本产品时，为提供给您服务之目的，本产品可能在您使用该应用某些场景下向您申请终端设备的如下权限，当然您可以拒绝开启以下权限，拒绝不会影响您对本产品其他功能的使用：</span>
            </p>
            <p id="w-e-element-351" style="text-indent: 24pt; "><span
                            style="color: rgb(0, 0, 0); ">访问相机：您可以使用摄像头进行拍摄并上传图片；</span>
            </p>
            <p id="w-e-element-352" style="text-indent: 24pt; "><span
                            style="color: rgb(0, 0, 0); ">访问本地存储：通过开启本地存储权限，将本产品内的书籍下载到您的手机存储；</span>
            </p>
            <p id="w-e-element-353" style="text-indent: 24pt; "><span
                            style="color: rgb(0, 0, 0); ">访问照片：您可以直接选择手机内的照片或图片进行上传或与客服沟通时提供证明；</span>
            </p>
            <p id="w-e-element-354" style="text-indent: 24pt; "><span
                            style="color: rgb(0, 0, 0); ">开启推送：您可以通过开启推送权限来接收本公众号推送的消息，您也可以关闭该权限；</span>
            </p>
            <p id="w-e-element-355" style="text-indent: 24pt; "><span
                            style="color: rgb(0, 0, 0); ">开启无线数据：您可以通过连接无线网络或蜂窝网络来实现本产品需要的联网功能；</span>
            </p>
            <p id="w-e-element-356" ><span
                            style="color: rgb(0, 0, 0); ">6、第三方SDK接入服务所需开通的权限。</span></p>
            <p id="w-e-element-357" ><span
                            style="color: rgb(0, 0, 0); ">
                            我们暂无接入第三方SDK的服务，若后续存在第三方SDK服务，我们会更新政策通知您。</span></p>
            <p id="w-e-element-358" style="text-indent: 7.5pt; "><strong
                            class="token bold"><span>二、我们如何使用Cookie和同类技术</span></strong></p>
            <p id="w-e-element-359" style="text-indent: 24pt; "><span
                            style="color: rgb(0, 0, 0); ">Cookie和同类技术是互联网中的通用常用技术。为确保产品正常运转、使您获得更轻松的访问体验、向您推荐您可能感兴趣的内容或广告等，我们可能会在您的移动设备上存储名为Cookie的小数据文件。Cookie通常包含标识符、站点名称以及一些号码和字符。借助于Cookie我们将记录您的登陆信息及操作信息，以便我们存储您的偏好及使用习惯，帮您省去重复输入注册信息的步骤，并帮助判断您的账户安全状态，以为您提供更轻松的用户体验和服务。</span>
            </p>
            <p id="w-e-element-360" style="text-indent: 24pt; "><span
                            style="color: rgb(0, 0, 0); ">我们不会将Cookie用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或停用Cookie。</span>
            </p>
            <p id="w-e-element-361" style="text-indent: 7.5pt; "><strong
                            class="token bold"><span>三、我们如何共享、转让、公开披露您的个人信息</span></strong></p>
            <p id="w-e-element-362" ><span
                            style="color: rgb(0, 0, 0); ">(一)共享</span></p>
            <p id="w-e-element-363" style="text-indent: 24.1pt; ">我们不会将您的个人信息向本公司及关联公司以外的任何公司、组织和个人共享，但以下情况除外：
            </p>
            <p id="w-e-element-364" style="text-indent: 24.1pt; ">
                <span>1、在获取明确同意的情况下共享：在获得您的明确同意后，我们会与其他方共享您的个人信息。</span>
            </p>
            <p id="w-e-element-365" style="text-indent: 24.1pt; ">
                <span>2、我们可能会根据法律法规规定，或按政府主管部门的强制性规定，对外共享您的个人信息。</span>
            </p>
            <p id="w-e-element-366" style="text-indent: 24pt; "><span
                            style="color: rgb(0, 0, 0); ">3、与授权合作伙伴共享：仅为实现本政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。</span>
            </p>
            <p id="w-e-element-367" style="text-indent: 24pt; "><span
                            style="color: rgb(0, 0, 0); ">目前，我们的授权合作伙伴包括以下几大类型：</span></p>
            <p id="w-e-element-368" style="text-indent: 24pt; "><span
                            style="color: rgb(0, 0, 0); ">1)广告、分析服务类的授权合作伙伴。除非得到您的许可，否则我们不会将您的个人身份信息(指可以识别您身份的信息，通过这些信息可以联系到您或识别您的身份)与提供广告、分析服务的合作伙伴分享。但我们可能会将您的匿名化的用户画像与广告、分析服务类的授权合作伙伴共享，以帮助其在不识别您的个人的前提下提升广告有效触达率。</span>
            </p>
            <p id="w-e-element-369" style="text-indent: 24pt; "><span
                            style="color: rgb(0, 0, 0); ">2)供应商、服务提供商和其他合作伙伴。我们将信息发送给在全球范围内支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括提供技术基础设施服务、分析我们服务的使用方式、衡量广告和服务的有效性、提供客户服务、支付便利或进行学术研究和调查。</span>
            </p>
            <p id="w-e-element-370" ><span
                            style="color: rgb(0, 0, 0); ">(二)转让</span></p>
            <p id="w-e-element-371" style="text-indent: 24.1pt; ">
                <span>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</span>
            </p>
            <p id="w-e-element-372" style="text-indent: 24.1pt; ">
                <span>1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</span>
            </p>
            <p id="w-e-element-373" style="text-indent: 24.1pt; ">
                <span>2、在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</span>
            </p>
            <p id="w-e-element-374" ><span
                            style="color: rgb(0, 0, 0); ">(三)公开披露</span></p>
            <p id="w-e-element-375" ><span>我们仅会在以下情况下，公开披露您的个人信息：</span></p>
            <p id="w-e-element-376" ><span>1、获得您明确同意后；</span></p>
            <p id="w-e-element-377" >
                <span>2、基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。</span>
            </p>
            <p id="w-e-element-378" ><span
                            style="color: rgb(0, 0, 0); ">(四)对外共享可能涉及的个人信息类型：设备识别码；</span>
            </p>
            <p id="w-e-element-379" style="text-indent: 24.1pt; ">
                <span>我们已知晓对外共享、转让、公开披露个人信息所承担的相应法律责任，并将采取合理措施保障个人信息安全。</span>
            </p>
            <p id="w-e-element-380" style="text-indent: 7.5pt; "><strong
                            class="token bold"><span>四、我们如何保护和保存您的个人信息</span></strong></p>
            <p id="w-e-element-381" ><span
                            style="color: rgb(0, 0, 0); ">（一）技术保护措施</span></p>
            <p id="w-e-element-382" style="text-indent: 24.1pt; ">
                <span>我们非常重视您个人信息的安全，将努力采取各种符合业界标准的合理的安全措施来保护您的信息，使您的信息不会被泄漏、毁损或者丢失，包括但不限于SSL、隐私信息加密存储、数据中心的访问控制。</span><span
                            style="color: rgb(0, 0, 0); ">我们会使用加密技术提高个人信息的安全性；我们会使用受信赖的保护机制防止个人信息遭到恶意攻击；我们会部署访问控制机制，尽力确保只有授权人员才可访问个人信息。</span>
            </p>
            <p id="w-e-element-383" ><span
                            style="color: rgb(0, 0, 0); ">（二）安全管理体系</span></p>
            <p id="w-e-element-384" style="text-indent: 24pt; "><span
                            style="color: rgb(0, 0, 0); ">我们有行业先进的以数据为核心，围绕数据生命周期进行的数据安全管理体系，从组织建设、制度设计、人员管理、产品技术、个人信息安全影响评估等方面多维度提升整个系统的安全性。</span>
            </p>
            <p id="w-e-element-385" style="text-indent: 24pt; "><span
                            style="color: rgb(0, 0, 0); ">我们对可能接触到您的信息的员工或外包人员也采取了严格管理，包括但不限于根据岗位的不同采取不同的权限控制，与他们签署保密协议，监控他们的操作情况等措施。</span>
            </p>
            <p id="w-e-element-386" ><span
                            style="color: rgb(0, 0, 0); ">（三）信息安全事件处理</span></p>
            <p id="w-e-element-387" style="text-indent: 24pt; "><span
                            style="color: rgb(0, 0, 0); ">尽管有前述安全措施，但同时也请您理解在信息网络上不存在“完善的安全措施”。
                        </span><span>如不幸发生个人信息安全事件后，我们将按照法律法规的要求向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。事件相关情况我们将以电话、推送通知等可行的方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。</span>
            </p>
            <p id="w-e-element-388" ><span
                            style="color: rgb(0, 0, 0); ">（四）保存期限</span></p>
            <p id="w-e-element-389" style="text-indent: 24.1pt; "><span>我们仅在中国大陆地区存放您的个人信息。我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本政策所述目的所需的且法律规定的最短期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。</span>
            </p>
            <p id="w-e-element-390" style="text-indent: 24pt; "><span
                            style="color: rgb(0, 0, 0); ">在您的个人信息超出保留期间后，我们会根据法律法规的要求删除您的个人信息、或使其匿名化处理。</span>
            </p>
            <p id="w-e-element-391" style="text-indent: 7.5pt; "><strong
                            class="token bold"><span>五、您的权利</span></strong></p>
            <p id="w-e-element-392" ><span
                            style="color: rgb(0, 0, 0); ">按照中国相关的法律、法规、标准，我们保障您对自己的个人信息行使以下权利：</span>
            </p>
            <p id="w-e-element-393" ><span
                            style="color: rgb(0, 0, 0); ">(一) 访问您的个人信息</span></p>
            <p id="w-e-element-394" ><span
                            style="color: rgb(0, 0, 0); ">您有权通过用户中心自行访问您的个人信息，法律法规规定的例外情况除外。</span>
            </p>
            <p id="w-e-element-395" ><span
                            style="color: rgb(0, 0, 0); ">(二)更正您的个人信息</span></p>
            <p id="w-e-element-396" ><span
                            style="color: rgb(0, 0, 0); ">当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正。</span>
            </p>
            <p id="w-e-element-397" ><span
                            style="color: rgb(0, 0, 0); ">(三)删除您的个人信息</span></p>
            <p id="w-e-element-398" ><span
                            style="color: rgb(0, 0, 0); ">在下述情形中，您可以向我们提出删除个人信息的请求：</span>
            </p>
            <p id="w-e-element-399" ><span
                            style="color: rgb(0, 0, 0); ">1、我们处理个人信息的行为违反法律法规；</span></p>
            <p id="w-e-element-400" ><span
                            style="color: rgb(0, 0, 0); ">2、我们收集、使用您的个人信息，却未征得您的同意；</span>
            </p>
            <p id="w-e-element-401" ><span
                            style="color: rgb(0, 0, 0); ">3、我们处理个人信息的行为违反了与您的约定；</span>
            </p>
            <p id="w-e-element-402" ><span
                            style="color: rgb(0, 0, 0); ">4、您不再使用我们的产品或服务，或您注销了账号；</span>
            </p>
            <p id="w-e-element-403" ><span
                            style="color: rgb(0, 0, 0); ">5、我们不再为您提供产品或服务。</span></p>
            <p id="w-e-element-404" >
                <span>若我们决定遵循您的请求，我们还将同时通知从我们获得您的个人信息的实体要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。</span>
            </p>
            <p id="w-e-element-405" >
                <span>当您从我们的服务中删除信息后，我们可能不会立即在备份系统中删除相应的信息，但会在备份更新时删除这些信息。</span>
            </p>
            <p id="w-e-element-406" ><span
                            style="color: rgb(0, 0, 0); ">您随时可注销此前注册的账户，在注销账户之后，我们将停止为您提供产品或服务，并依据您的要求，删除您的个人信息，法律法规另有规定的除外。</span>
            </p>
            <p id="w-e-element-407" ><span>在以下情形中，按照法律法规要求，我们将无法遵循您的个人信息删除请求：</span>
            </p>
            <p id="w-e-element-408" ><span>1、与国家安全、国防安全直接相关的；</span></p>
            <p id="w-e-element-409" ><span>2、与公共安全、公共卫生、重大公共利益直接相关的；</span></p>
            <p id="w-e-element-410" ><span>3、与犯罪侦查、起诉、审判和判决执行等直接相关的；></span></p>
            <p id="w-e-element-411" ><span>4、有充分证据表明您存在主观恶意或滥用权利的；</span></p>
            <p id="w-e-element-412" ><span>5、响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</span>
            </p>
            <p id="w-e-element-413" ><span>6、涉及商业秘密的。</span></p>
            <p id="w-e-element-414" ><span
                            style="color: rgb(0, 0, 0); ">(四)响应您的上述请求</span></p>
            <p id="w-e-element-415" >
                <span>为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。</span>
            </p>
            <p id="w-e-element-416" ><span>我们将在三十天内作出答复。如您不满意，还可以通过与客服联系进行申诉。</span>
            </p>
            <p id="w-e-element-417" style="text-indent: 7.5pt; "><strong>六、我们如何处理儿童的个人信息</strong></p>
            <p id="w-e-element-418" ><span
                            style="color: rgb(0, 0, 0); ">我们的产品、网站和服务主要面向成人。我们重视儿童等未成年人的个人信息保护，</span><span>如您为未满18周岁的未成年人，在您使用我们提供的相关服务之前，您应在您的父母或者其他监护人的监护、指导下共同阅读并同意本隐私政策，并在征得您的监护人同意的前提下使用我们的服务或向我们提供信息。</span>
            </p>
            <p id="w-e-element-419" >
                <span>对于经父母或监护人同意使用我们的产品或服务而收集未成年人个人信息的情况，我们只会在法律法规允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用、共享、转让或披露此信息。如果我们发现在未事先获得可证实的父母同意的情况下收集了未成年人的个人信息，则会尽快删除相关信息。</span>
            </p>
            <p id="w-e-element-420" style="text-indent: 7.5pt; "><strong
                            class="token bold"><span>七、您的个人信息如何在全球范围转移</span></strong></p>
            <p id="w-e-element-421" ><span
                            style="color: rgb(0, 0, 0); ">目前我们不会跨境传输或存储您的个人信息。将来如需跨境传输或存储的，我们会向您告知信息出境的目的、接收方、安全保障措施和安全风险，并征得您的同意。</span>
            </p>
            <p id="w-e-element-422" style="text-indent: 7.5pt; "><strong
                            class="token bold"><span>八、本政策如何更新</span></strong></p>
            <p id="w-e-element-423" >
                <span>本隐私政策更新后，我们会在您登录及版本更新时以推送通知、弹窗、公告等形式向您展示变更后的隐私政策与内容，以便您及时了解本隐私政策的最新版本。我们将严格遵循向您披露的隐私政策等收集使用规则开展个人信息处理活动，如个人信息使用目的发生变化时会再次征得您的同意，如您继续使用我们的服务，表示同意接受修订后的本政策的内容。</span>
            </p>
            <p id="w-e-element-424" style="text-indent: 7.5pt; "><strong
                            class="token bold"><span>九、本政策的适用</span></strong></p>
            <p id="w-e-element-425" ><span
                            style="color: rgb(0, 0, 0); ">本产品的所有服务均适用本政策。</span></p>
            <p id="w-e-element-426" ><span
                            style="color: rgb(0, 0, 0); ">当您在首次登陆本产品或将要进行充值时，我们会提示您进行阅读本政策，并征得您的同意。</span>
                <span>除非另有约定或者法律规定，本隐私政策不适用于本公司链接到其他第三方的产品或服务，您使用这些第三方服务（包括您向这些第三方提供的任何个人信息），将受这些第三方的服务条款及隐私政策约束（而非本隐私政策），具体规定请您仔细阅读第三方的条款。请您妥善保护自己的个人信息，仅在必要的情况下向第三方提供。</span>
            </p>
            <p id="w-e-element-427" style="text-indent: 7.5pt; "><strong
                            class="token bold"><span>十、争议管辖</span></strong></p>
            <p id="w-e-element-428" ><span
                            style="color: rgb(0, 0, 0); ">本隐私政策的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律。</span>
            </p>
            <p id="w-e-element-429" >
                <span>若您和我们发生任何纠纷或争议，首先应友好协商解决；协商不成的，均提请杭州市滨江区人民法院诉讼解决。</span>
            </p>
            <p id="w-e-element-430" style="text-indent: 7.5pt; "><strong
                            class="token bold"><span>十一、联系我们</span></strong></p>
            <p id="w-e-element-431" style="text-indent: 24pt;"><span
                            style="color: rgb(0, 0, 0); ">您在产品使用的过程中及对本隐私政策有任何疑问、意见和建议的，均可通过在线客服与我们联系。</span>
            </p>
        </div>

    </div>
</template>
<script>
import navBar from "../components/navbar.vue";
export default {
    components: {
        navBar
    },
    data() {
        return {
            isEntranceData: "",
            pageType: ''
        }
    },
    mounted() {
        if (this.$route.query.isEntranceData) {
            this.isEntranceData = this.$route.query.isEntranceData;
        }
        if (this.$route.query.pageType) {
            this.pageType = this.$route.query.pageType;
        }
        var openid = this.$base.getStorage("openid");
        var isWxAuthorized = this.$base.getStorage("isWxAuthorized");
        var city = this.$base.getStorage("city");
        if (!openid) {
            //静默登录手动登录
        } else if (
            isWxAuthorized == 0 &&
            city == 1 &&
            openid &&
            !this.$store.state.user.isSNS
        ) {
            this.$base.setStorage("isSNS", true);
            this.$store.state.user.isSNS = true;
            this.$commonApi.snsapiUserinfo();
            this.insertPageAccessData();
        } else {
            this.insertPageAccessData();
        }
        this.$commonApi.share();
    },
    methods: {
        insertPageAccessData() {
            var prevPage = "";
            if (this.pageType === "bookCharge") {
                prevPage = "充值中心";
            } else if (this.pageType === "bookRember") {
                prevPage = "会员中心";
            }
            var params = {
                pageName: "隐私政策",
                pageRemark: "上级页面:" + prevPage,
                isEntranceData: this.isEntranceData,
            };
            this.$api.insertPageAccessData(params).then((res) => { });
        },
    }
}

</script>
<style scoped>
.content {
    padding: 20px;
    padding-top: calc(44px + env(safe-area-inset-top));

}
</style>


// WEBPACK FOOTER //
// src/view/Privacy/index.vue